import { render, staticRenderFns } from "./DetailPerformance.vue?vue&type=template&id=3f20b0fe&"
import script from "./DetailPerformance.vue?vue&type=script&lang=js&"
export * from "./DetailPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports